module.exports = __webpack_public_path__ + "static/Gallery-4-8a66bea78cfaa7de21f96750715cb42b.jpg";